import React, { useEffect, useState } from 'react';
import categoriesData from './CategoriesData';
import { useNavigate, useParams } from 'react-router-dom';
import './AIInterviewUnrolledCourse.css';
import { Helmet } from 'react-helmet';

const AiInterviewUnenrolledCourse = () => {
  const codingCategories = categoriesData;
  const [resume, setResume] = useState(null);
  const { courseName } = useParams();
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    if (!userId) {
      navigate('/login');
    }
  }, [navigate, userId]);

  const [selectedCategory, setSelectedCategory] = useState("Development");
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [experience, setExperience] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedSubcategory('');
    setSelectedCourse('');
  };

  const handleSubcategoryChange = (event) => {
    setSelectedSubcategory(event.target.value);
    setSelectedCourse('');
  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  const handleExperienceChange = (event) => {
    const value = event.target.value;

    if (value === "" || /^[0-9\b]+$/.test(value)) {
      setExperience(value);
    }
  };



  const handleSubmit = () => {
    if (!selectedCourse || !experience) {
      setErrorMessage('Please select a course and enter your experience.');
    } else {
      setErrorMessage('');
      console.log('Category:', selectedCategory, 'Subcategory:', selectedSubcategory, 'Course:', selectedCourse, 'Experience:', experience);

      navigate(`/unenrolled-ai-interview/${selectedCourse}/${experience}`, { state: { resume } });
    }
  };

  const renderSubcategories = () => {
    const categoryData = codingCategories.find(category => category.title === selectedCategory);
    if (!categoryData) return null;

    return categoryData.subcategories.map((subcategory, index) => (
      <option key={index} value={subcategory.title}>{subcategory.title}</option>
    ));
  };

  const renderCourses = () => {
    const categoryData = codingCategories.find(category => category.title === selectedCategory);
    if (!categoryData) return null;

    const subcategoryData = categoryData.subcategories.find(subcategory => subcategory.title === selectedSubcategory);
    if (!subcategoryData) return null;

    return subcategoryData.popularTopics.map((course, index) => (
      <option key={index} value={course}>{course}</option>
    ));
  };

  // In AiInterviewUnenrolledCourse component
  const handleResumeChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      // Store the file as base64 or file name in localStorage (depends on your requirement)
      localStorage.setItem(`resume-${courseName}`, file.name);  // storing file name
      setResume(file);  // Optionally store the file in state for immediate use
      setErrorMessage('');
    } else {
      setErrorMessage('Please upload a valid PDF file.');
    }
  };


  return (
    <div className="ai-interview-unenrolled-course">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": selectedCourse
              ? `AI Interview for ${selectedCourse}`
              : "AI Interview Service",
            "description":
              "SkillzVerse provides AI-powered mock interviews tailored to your selected course and experience level. Get actionable insights and improve your confidence before real interviews.",
            "provider": {
              "@type": "Organization",
              "name": "SkillzVerse",
              "url": "https://skillzverse.com"
            },
            "areaServed": {
              "@type": "Country",
              "name": "India"
            },
            "url":
              selectedCourse && experience
                ? `https://skillzverse.com/unenrolled-ai-interview/${selectedCourse}/${experience}`
                : "https://skillzverse.com/ai-interview"
          })}
        </script>
      </Helmet>


      <h2 className="ai-interview-unenrolled-course-header">AI Interview</h2>
      <p className="ai-interview-unenrolled-course-description">Choose a course, provide your relevant years of experience, and continue.</p>
      <ul className="ai-interview-unenrolled-course-list">
        <li>
          <label htmlFor="category-select" className="ai-interview-category-label">Select Category:</label>
          <select
            id="category-select"
            value={selectedCategory}
            onChange={handleCategoryChange}
            className="ai-interview-category-select"
          >
            <option value="">-- Select Category --</option>
            {codingCategories.map((category, index) => (
              <option key={index} value={category.title}>{category.title}</option>
            ))}
          </select>
        </li>

        {selectedCategory && (
          <li>
            <label htmlFor="subcategory-select" className="ai-interview-subcategory-label">Select Subcategory:</label>
            <select
              id="subcategory-select"
              value={selectedSubcategory}
              onChange={handleSubcategoryChange}
              className="ai-interview-subcategory-select"
            >
              <option value="">-- Select Subcategory --</option>
              {renderSubcategories()}
            </select>
          </li>
        )}

        {selectedSubcategory && (
          <li>
            <label htmlFor="course-select" className="ai-interview-course-label">Select Course:</label>
            <select
              id="course-select"
              value={selectedCourse}
              onChange={handleCourseChange}
              className="ai-interview-course-select"
            >
              <option value="">-- Select Course --</option>
              {renderCourses()}
            </select>
          </li>
        )}

        <li>
          <label htmlFor="experience-input" className="ai-interview-experience-label">Enter Your Years of Experience:</label>
          <input
            type="text"
            id="experience-input"
            value={experience}
            onChange={handleExperienceChange}
            placeholder="Enter your experience"
            className="ai-interview-experience-input"
          />
        </li>

        {/* <li>
          <label htmlFor="resume-input">Upload Resume:</label>
          <input
            type="file"
            id="resume-input"
            accept=".pdf"
            onChange={handleResumeChange}
          />
        </li> */}

        {errorMessage && <p className="ai-interview-error-message">{errorMessage}</p>}

        <li>
          <button onClick={handleSubmit} className="ai-interview-submit-btn">
            Continue
          </button>
        </li>
      </ul>
    </div>
  );
};

export default AiInterviewUnenrolledCourse;
